import { __assign } from "tslib";
/** @jsx jsx */
import { jsx, ClassNames } from '@emotion/core';
import { elemBeforeCSS, elemAfterCSS, descriptionCSS, contentCSS, truncateCSS, contentCSSWrapper, } from './styles';
var defaultRender = function (Component, props) { return (jsx(Component, __assign({}, props))); };
var BaseItem = function (_a) {
    var children = _a.children, description = _a.description, elemAfter = _a.elemAfter, elemBefore = _a.elemBefore, overrides = _a.overrides;
    var renderTitle = (overrides && overrides.Title && overrides.Title.render) || defaultRender;
    return (jsx("div", { css: contentCSSWrapper },
        elemBefore && (jsx("span", { "data-item-elem-before": true, css: elemBeforeCSS }, elemBefore)),
        children && (jsx("span", { css: contentCSS },
            jsx(ClassNames, null, function (_a) {
                var css = _a.css;
                return renderTitle('span', {
                    children: children,
                    className: css(truncateCSS),
                    'data-item-title': true,
                });
            }),
            description && (jsx("span", { "data-item-description": true, css: descriptionCSS }, description)))),
        elemAfter && (jsx("span", { "data-item-elem-after": true, css: elemAfterCSS }, elemAfter))));
};
export default BaseItem;
//# sourceMappingURL=base-item.js.map